export default __webpack_public_path__ + "static/blog-banner-9dffa699113568251524f07ae2554c3f.jpg";